@use "ui/styles/colors";
@use "ui/styles/sizes";

.verticalWrapper {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  background-color: colors.$gray10;
}

.horizontalWrapper {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: row;
  flex: 1;
  background-color: transparent;
  position: relative;
}

.contentWrapper {
  height: 100%;
  background-color: var(--content-background-color);
  --table-controls-background-color: var(--content-background-color);
  overflow-y: auto;
  flex: 1;
  border: 1px solid colors.$gray20;

  &.withSideNav {
    border-start-start-radius: sizes.$s4;
    box-shadow: 0px 2px 4px 0px colors.$alphaDark05;
  }

  :global {
    h1 {
      font-weight: normal;
      font-size: 24px;
    }

    .builder-portal-layout-content {
      margin: 0 auto;
      width: 100%;
      max-width: calc(sizes.$configMaxWidth + sizes.$configGutterWidth * 2);
      padding-left: sizes.$configGutterWidth;
      padding-right: sizes.$configGutterWidth;
      padding-bottom: sizes.$s10;

      &.spacing-top {
        padding-top: sizes.$s10;
      }
    }
  }
}
